import React from 'react';
import { Box, Heading, Text, Button, VStack, useColorModeValue } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';

const NotFound = () => {
  const bgColor = useColorModeValue('gray.50', 'gray.800');
  const textColor = useColorModeValue('gray.600', 'gray.300');
  const headingColor = useColorModeValue('red.500', 'red.400');

  return (
    <Box
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg={bgColor}
      px={4}
    >
      <VStack spacing={6} textAlign="center">
        <Heading
          as="h1"
          size="2xl"
          color={headingColor}
          fontWeight="extrabold"
          letterSpacing="tight"
        >
          404
        </Heading>
        
        <Heading as="h2" size="lg" fontWeight="semibold">
          Page Not Found
        </Heading>
        
        <Text fontSize="lg" color={textColor} maxW="md">
          Oops! The page you're looking for doesn't exist or has been moved.
        </Text>
        
        <Button
          as={RouterLink}
          to="/"
          leftIcon={<FaHome />}
          colorScheme="red"
          variant="solid"
          size="lg"
          mt={4}
        >
          Return Home
        </Button>
      </VStack>
    </Box>
  );
};

export default NotFound;